// extracted by css-extract-rspack-plugin
export default {"form":"_sYWTfqWGJgYcUcL__form___"};